// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* IE 2026 10 22 / ODOO-5800: форма легенды в слое над формой ячейки — базовые стили .dropdown-legend-pop / .dropdown-legend-* глобальные (Dropdown.vue); здесь — только слой */\n.cell-legend-pop { box-sizing: border-box;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
